import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const rolesAdapter = getAdapter({ idFieldName: 'id' });

const rolesSlice = createSlice({
  name: 'roles',
  initialState: rolesAdapter.getInitialState(),
  reducers: {
    setRoles: (state, { payload: { roles } }) => {
      rolesAdapter.setAll(state, roles);
    },
  },
});

const selectors = rolesAdapter.getSelectors(({ roles }) => roles);

export const getRoles = (state) => selectors.selectAll(state);

export const {
  setRoles,
} = rolesSlice.actions;

export default rolesSlice.reducer;
